import { ThemeOptions } from '@mui/material';

interface CustomTheme {
  custom: {
    app: {
      colors: {
        start: string;
        center: string;
        end: string;
      };
    };
    card: {
      background: {
        primary: string;
        secondary: string;
      };
    };
  };
}

declare module '@mui/material/styles' {
  interface Theme extends CustomTheme {}
  interface ThemeOptions extends Partial<CustomTheme> {}
}

const commonTheme: ThemeOptions = {
  typography: {
    fontFamily: '\'Plus Jakarta Sans\', \'Source Sans 3\', \'Inter\', sans-serif'
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '\'Plus Jakarta Sans\', \'Source Sans 3\', \'Inter\', sans-serif'
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 456,
      md: 768,
      lg: 1024,
      xl: 1440
    }
  }
};

export default commonTheme;
